import React, { useContext, useState, useEffect, useRef } from "react";
import { Chart, ChartConfiguration, LineController, LineElement, PointElement, LinearScale, Title, TimeScale } from 'chart.js'
import 'chartjs-adapter-date-fns';
import { Scatter, Bubble } from "react-chartjs-2";
import moment from 'moment-timezone';
import ProgressBar from 'react-bootstrap/ProgressBar';
import axios from "axios";
import { APIURL } from "../../../../Global";
import { SOCKETURL } from "../../../../Global";
import SimpleBar from "simplebar-react";
import "../monitor.css"
import "simplebar-react/dist/simplebar.min.css";
import {
  Badge,
  Button,
  Card,
  Tooltip,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Form,
  OverlayTrigger,

} from "react-bootstrap";
function CareTouch(props) {
  const [count, setCount] = useState(0)
  const [refresh, setRefresh] = useState(false)
  const [date, setDate] = useState(new Date())
  const [date1, setDate1] = useState(new Date().toLocaleDateString('en-CA'))
  const currentTime = new Date().getTime();
  const currentDate = new Date();
  const [tapped, setTapped] = useState(false)
  const [tapedData, setTapedData] = useState([])
  const [startTime, setStartTime] = useState(currentDate.setHours(1, 0, 0, 0))
  const [endTime, setEndTime] = useState(currentDate.setHours(24, 0, 0, 0));
  const checkTime = new Date();
  const morningStart = new Date(checkTime.setHours(7, 0, 0, 0)).getTime();
  const morningEnd = new Date(checkTime.setHours(11, 59, 0, 0)).getTime();

  const afternoonStart = new Date(checkTime.setHours(12, 0, 0, 0)).getTime();
  const afternoonEnd = new Date(checkTime.setHours(15, 29, 0, 0)).getTime();
  const [timeRefresh, setTimeRefres] = useState(false)
  const eveningStart = new Date(checkTime.setHours(15, 30, 0, 0)).getTime();
  const eveningEnd = new Date(checkTime.setHours(19, 29, 0, 0)).getTime();

  const nightStart = new Date(checkTime.setHours(19, 30, 0, 0)).getTime();
  const nightEnd = new Date(checkTime.setHours(23, 59, 59, 999)).getTime();

  const [serveTime, setServeTime] = useState((currentTime >= morningStart && currentTime <= morningEnd) ?
    'morning'
    : (currentTime >= afternoonStart && currentTime <= afternoonEnd) ?
      'afternoon'
      : (currentTime >= eveningStart && currentTime <= eveningEnd) ?
        'evening'
        : (currentTime >= nightStart && currentTime <= nightEnd) ?
          'night' : "")
  function getPrevDate(date1) {
    if (date1 === "") {
      setDate1(new Date().toLocaleDateString('en-CA'))
      setDate(new Date())
    }
    else {
      var yest = new Date(date1);
      yest.setDate(yest.getDate() - 1);
      setDate(yest)

    }


  }
  function getNextDate(date1) {
    var tomorrow = new Date(date1)
    tomorrow.setDate(tomorrow.getDate() + 1);
    setDate(tomorrow)
  }
  useEffect(() => {
    handlingWebsocket();
  }, [])
  const webSocket = useRef(null);
  const handlingWebsocket = () => {
    // if(socketLoaded) {
    //   return;
    // }
    const tokenString = sessionStorage.getItem("usertoken");
    const hospId = sessionStorage.getItem("hospId");
    let str = tokenString.replace(/["]+/g, "");
    webSocket.current = new WebSocket(
      `${SOCKETURL}/ws/call_action/nfc_sp_` +
      hospId +
      "/?token=" +
      str
    );
    webSocket.current.onopen = () => {
      // on connecting, do nothing but log it to the console
      // setSocketLoaded(true);
    };

    webSocket.current.onmessage = (evt) => {

      const message = JSON.parse(evt.data);
      console.log(message);
      if (message.message.message_type === "new_taps") {
        setTapped(true)

        setCount(message.message.count)
      }


    };

    webSocket.current.onclose = () => {

    };
  }
  useEffect(() => {
    // if (date.toLocaleDateString('en-CA') === new Date().toLocaleDateString('en-CA')) {
      if (currentTime >= morningStart && currentTime <= morningEnd) {
        setServeTime('morning')
      } else if (currentTime >= afternoonStart && currentTime <= afternoonEnd) {
        setServeTime('afternoon')
      } else if (currentTime >= eveningStart && currentTime <= eveningEnd) {
        setServeTime('evening')
      } else if (currentTime >= nightStart && currentTime <= nightEnd) {
        setServeTime('night')
      }
      else if (currentTime > nightEnd || currentTime <= morningStart) {
        setServeTime('late_night')
      }
    // }
    // else { setServeTime("morning") }

    if (date !== "") {
      setDate1(date.toLocaleDateString('en-CA'))
    }
    else {
      setDate1("")
    }
    setStartTime(new Date(date).setHours(1, 0, 0, 0))
    setEndTime(new Date(date).setHours(24, 0, 0, 0))
  }, [date, timeRefresh])


  useEffect(() => {
    setTapedData([]);
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const tokenString = sessionStorage.getItem("usertoken");
    let str = tokenString.replace(/["]+/g, "");
    const fetchData = async (pageNumber) => {
      try {
        const response = await axios
        .get(`${APIURL}/api/v1/service-provider/nfctaps/?date=${date1}&serv_time=${serveTime}&timeZone=${currentTimezone}&page=${pageNumber}`,
          {
            headers: {
              Authorization: "Token " + str,
            },
          }
        );
        
        if (response.data.status === "success") {
          setTapedData((prevData) => [...prevData, ...response.data.taps]);
          console.log(...response.data.taps)
          setTapped(false);
          if (response.data.has_next) {
            fetchData(pageNumber + 1); // Fetch next page recursively
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    
    fetchData(1); // Start fetching from the first page
  }, [serveTime, date1, refresh]);  
  return (<>
    {/* <div className=" row " style={{width: "100%",paddingTop:"1%",paddingLeft:"1%"}}>
     
      <div className=" col-3">
     
      </div>
    </div> */}
    <div className="row" style={{ width: "100%", paddingTop: "2%", paddingLeft: "2%" }} >

      <div className="col-2">
        <div className=" icons-right-not" style={{padding:0, marginLeft: "1%", display: "flex", justifyContent: "space-between" ,margin:"auto"}}>
          <button onClick={() => { getPrevDate(date) }} style={{ float: "left", background: "none", padding:".1em", paddingTop:0, justifyContent:"center" }} >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 26 26"><g fill="currentColor"><path fill-rule="evenodd" d="M13.5 26C20.404 26 26 20.404 26 13.5S20.404 1 13.5 1S1 6.596 1 13.5S6.596 26 13.5 26m0-2C19.299 24 24 19.299 24 13.5S19.299 3 13.5 3S3 7.701 3 13.5S7.701 24 13.5 24" clip-rule="evenodd" opacity=".2" /><path fill-rule="evenodd" d="m14.453 14l4.2-5.04c1.28-1.536-1.025-3.457-2.305-1.92l-4.957 5.948c-.256.272-.42.63-.418 1.012c-.002.382.162.74.418 1.012l4.957 5.948c1.28 1.537 3.585-.384 2.304-1.92z" clip-rule="evenodd" opacity=".2" /><path d="m15.384 18.68l-5-6l-.768.64l5 6z" /><path d="m14.616 19.32l-5-6c-.427-.512.341-1.152.768-.64l5 6c.427.512-.341 1.152-.768.64" /><path d="m14.616 6.68l-5 6l.768.64l5-6z" /><path d="m15.384 7.32l-5 6c-.427.512-1.195-.128-.768-.64l5-6c.427-.512 1.195.128.768.64" /><path fill-rule="evenodd" d="M13 24.5c6.351 0 11.5-5.149 11.5-11.5S19.351 1.5 13 1.5S1.5 6.649 1.5 13S6.649 24.5 13 24.5m0 1c6.904 0 12.5-5.596 12.5-12.5S19.904.5 13 .5S.5 6.096.5 13S6.096 25.5 13 25.5" clip-rule="evenodd" /></g></svg></button>


          <div style={{justifyContent: "center"}}>{date1 === new Date().toLocaleDateString('en-CA') ? <span style={{ color: "rgb(43, 147, 160)", width: "100%", marginTop: "1%" }} className='day-head'>Today</span>
            : <span style={{ color: "rgb(43, 147, 160)", width: "100%", marginTop: "1.5%", fontSize: "x-small" }} className='day-head'>{date1}</span>}</div>



          <button onClick={() => { getNextDate(date) }} disabled={date1 === new Date().toLocaleDateString('en-CA')} style={{ background: "none", float: "right", padding:"0.1em",paddingTop:0 }}>{date1 === new Date().toLocaleDateString('en-CA') ? <> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 26 26"><g fill="currentColor"><path fill-rule="evenodd" d="M13.5 26C20.404 26 26 20.404 26 13.5S20.404 1 13.5 1S1 6.596 1 13.5S6.596 26 13.5 26m0-2C19.299 24 24 19.299 24 13.5S19.299 3 13.5 3S3 7.701 3 13.5S7.701 24 13.5 24" clip-rule="evenodd" opacity=".2" /><path d="M18.812 14.729a1.49 1.49 0 0 1-.177.252l-4.983 5.98a1.5 1.5 0 0 1-2.304-1.921l4.2-5.04l-4.2-5.04a1.5 1.5 0 1 1 2.304-1.92l5 6a1.5 1.5 0 0 1 .16 1.689" opacity=".2" /><path d="M10.116 7.32a.5.5 0 1 1 .768-.64l5 6a.5.5 0 0 1-.768.64z" /><path d="M10.884 19.32a.5.5 0 0 1-.768-.64l5-6a.5.5 0 1 1 .768.64z" /><path d="M4.15 4.878a.514.514 0 0 1 .728-.727l16.971 16.971a.514.514 0 0 1-.727.727z" /><path fill-rule="evenodd" d="M13 24.5c6.351 0 11.5-5.149 11.5-11.5S19.351 1.5 13 1.5S1.5 6.649 1.5 13S6.649 24.5 13 24.5m0 1c6.904 0 12.5-5.596 12.5-12.5S19.904.5 13 .5S.5 6.096.5 13S6.096 25.5 13 25.5" clip-rule="evenodd" /></g></svg> </> :
            <><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 26 26"><g fill="currentColor"><path fill-rule="evenodd" d="M13.5 26C20.404 26 26 20.404 26 13.5S20.404 1 13.5 1S1 6.596 1 13.5S6.596 26 13.5 26m0-2C19.299 24 24 19.299 24 13.5S19.299 3 13.5 3S3 7.701 3 13.5S7.701 24 13.5 24" clip-rule="evenodd" opacity=".2" /><path d="M18.812 14.729a1.49 1.49 0 0 1-.177.252l-4.983 5.98a1.5 1.5 0 0 1-2.304-1.921l4.2-5.04l-4.2-5.04a1.5 1.5 0 1 1 2.304-1.92l5 6a1.5 1.5 0 0 1 .16 1.689" opacity=".2" /><path d="M10.116 7.32a.5.5 0 1 1 .768-.64l5 6a.5.5 0 0 1-.768.64z" /><path d="M10.884 19.32a.5.5 0 0 1-.768-.64l5-6a.5.5 0 1 1 .768.64z" /><path fill-rule="evenodd" d="M13 24.5c6.351 0 11.5-5.149 11.5-11.5S19.351 1.5 13 1.5S1.5 6.649 1.5 13S6.649 24.5 13 24.5m0 1c6.904 0 12.5-5.596 12.5-12.5S19.904.5 13 .5S.5 6.096.5 13S6.096 25.5 13 25.5" clip-rule="evenodd" /></g></svg></>}</button></div>
        <br />

        <div className={serveTime === "morning" ? " icons-right " : " icons-right-not "} onClick={() => {
          setServeTime("morning")
        }} >
          <Card.Body>
            <Row>
              <Col xs="3">
                <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 128 128"><path fill="#fcc11a" d="M37.41 41.95c-9.71 12.48-9.54 34.65 2.87 45.64c14.09 12.47 33.92 12.34 46.39.87c14.95-13.76 14.09-36.66.87-49.63c-13.29-13.04-37.04-13.72-50.13 3.12" /><path fill="#fee269" d="M53 37.67c-3.84-1.7-8.04 2.93-9.87 6.09c-1.83 3.17-3.53 9.38.37 10.97c3.9 1.58 6.7-1.1 9.51-5.73c2.79-4.63 4.38-9.38-.01-11.33" /><path fill="#ffa722" d="M63 20.27c-.93 1.74-.62 3.08 1.23 3.52c1.85.44 13.36 2.31 14.33 2.37c1.41.09 1.93-.97 1.76-2.2c-.18-1.23-2.99-18.46-3.25-20.04S75.14.76 73.55 2.87S63.7 18.96 63 20.27m29.8 11.96c-1.81.56-1.76 1.67-.79 3.08c.97 1.41 7.65 11.6 8.26 12.31c.62.7 1.67.88 2.55-.18c.88-1.05 11.86-16.45 12.66-17.41c1.32-1.58.53-3.25-1.49-2.73c-1.54.41-20.05 4.58-21.19 4.93m13.8 29.63c-1.3-.74-2.99-.53-3.43 1.14c-.44 1.67-2.37 13.8-2.55 14.86s.62 2.11 1.93 1.85s19.45-2.95 20.66-3.25c2.11-.53 2.81-2.64.62-4.22c-1.42-1.03-16-9.68-17.23-10.38M92.09 90.6c1.4-.75 2.64-.18 2.99 1.41c.35 1.58 4.22 17.76 4.84 20.75c.31 1.5-1.41 2.73-2.81 1.85c-1.41-.88-16.69-11.53-17.67-12.4c-1.41-1.23-.43-2.51.26-3.16c1.4-1.33 11.07-7.74 12.39-8.45m-42.55 8.88c-1.77-.17-2.29 1.41-2.02 2.81c.26 1.41 2.9 19.24 3.08 20.57c.26 1.93 2.29 2.73 3.6.79s10.35-16.4 11.08-17.76c1.32-2.46.35-2.99-.97-3.6c-1.31-.61-12.92-2.63-14.77-2.81M24.23 79c1.23-2.02 2.81-1.49 3.96.44c.78 1.32 7.38 10.2 8 11.16c.62.97.88 2.81-1.05 3.25c-1.95.45-17.68 4.58-20.14 5.02c-2.46.44-3.87-1.49-2.29-3.6c.92-1.24 10.82-15.12 11.52-16.27m-3.34-15.3c2.25 1 3.31.64 3.78-.97c.62-2.11 2.46-11.78 2.55-13.98c.06-1.43-.53-2.81-2.73-2.46S6.47 48.85 4.45 49.55c-2.35.82-2.18 3.4-.62 4.22c1.85.97 15.47 9.23 17.06 9.93m27.34-36.92c1.27-1.01.88-2.46-.26-3.25c-1.14-.79-15.26-11-17.05-12.4c-1.58-1.23-3.52-.79-2.99 2.02c.38 2.02 4.88 19.7 5.19 20.92c.35 1.41 1.41 2.11 2.64 1.23c1.21-.87 11.15-7.46 12.47-8.52" /></svg>

              </Col>
              <Col xs="9">
                <div className="numbers">
                  <p className="card-category">Morning</p>
                  <p className="card-category" style={{ fontSize: "x-small" }}><b>7AM-12PM </b></p>

                  {/* <Card.Title as="h4">{completed}/{completedPat}</Card.Title> */}
                </div>
              </Col>
            </Row>
          </Card.Body>

        </div><br />


        <div className={serveTime === "afternoon" ? " icons-right " : " icons-right-not "} onClick={() => {
          setServeTime("afternoon")
        }}>
          <Card.Body>
            <Row>
              <Col xs="3">

                <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 64 64"><path fill="#ffe62e" d="m20.5 59.7l7-7.2c-2.5-.5-4.8-1.5-6.9-2.9zm23-55.4l-7 7.2c2.5.5 4.8 1.5 6.9 2.9zM4.3 43.5l10.1-.1C13 41.3 12 39 11.5 36.5zm55.4-23l-10.1.1c1.3 2.1 2.3 4.4 2.9 6.9zm-55.4 0l7.2 7c.5-2.5 1.5-4.8 2.9-6.9zm55.4 23l-7.2-7c-.5 2.5-1.5 4.8-2.9 6.9zM20.5 4.3l.1 10.1c2.1-1.3 4.4-2.3 6.9-2.9zm23 55.4l-.1-10.1C41.3 51 39 52 36.5 52.5z" /><g fill="#ffce31"><path d="m14.8 44l-4 9.3l9.3-4C18 47.8 16.2 46 14.8 44m34.4-24l4-9.3l-9.2 4c2 1.5 3.8 3.3 5.2 5.3m-37.8 8.3L2 32l9.4 3.7c-.3-1.2-.4-2.4-.4-3.7s.1-2.5.4-3.7m41.2 7.4L62 32l-9.4-3.7c.2 1.2.4 2.5.4 3.7c0 1.3-.1 2.5-.4 3.7M20 14.8l-9.3-4l4 9.3c1.5-2.1 3.3-3.9 5.3-5.3m24 34.4l9.3 4l-4-9.3C47.8 46 46 47.8 44 49.2m-8.3-37.8L32 2l-3.7 9.4c1.2-.2 2.5-.4 3.7-.4s2.5.1 3.7.4m-7.4 41.2L32 62l3.7-9.4c-1.2.3-2.4.4-3.7.4s-2.5-.1-3.7-.4" /><circle cx="32" cy="32" r="19" /></g></svg>

              </Col>
              <Col xs="9">
                <div className="numbers">
                  <p className="card-category">Afternoon</p>
                  <p className="card-category" style={{ fontSize: "x-small" }}><b>12PM-3:30PM </b></p>


                </div>
              </Col>
            </Row>
          </Card.Body>

        </div><br />


        <div className={serveTime === "evening" ? " icons-right " : " icons-right-not "} onClick={() => {
          setServeTime("evening")
        }}>
          <Card.Body>
            <Row>
              <Col xs="3">
                <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 64 64"><path fill="#fbb041" d="M62.713 30.827L50.77 27.352a21.201 21.201 0 0 0-2.311-5.603c1.987-3.641 3.977-7.282 5.967-10.922c.544-.996-.541-2.086-1.539-1.538l-10.878 5.974a20.853 20.853 0 0 0-5.673-2.362c-1.183-4.03-2.365-8.06-3.548-12.1c-.313-1.071-1.853-1.075-2.168 0c-1.173 4.04-2.349 8.07-3.524 12.11a21.116 21.116 0 0 0-5.576 2.316c-3.666-2-7.333-4.01-10.999-6.01c-.994-.543-2.085.543-1.537 1.541l6.03 10.978a21.063 21.063 0 0 0-2.324 5.634L.805 30.854c-1.07.314-1.076 1.856 0 2.168l11.889 3.459a21.248 21.248 0 0 0 2.389 5.729c-1.978 3.618-3.956 7.235-5.932 10.854c-.546.996.539 2.087 1.537 1.54c3.613-1.985 7.227-3.97 10.841-5.953a21.062 21.062 0 0 0 5.636 2.332c1.159 3.964 2.322 7.924 3.483 11.883c.315 1.074 1.856 1.076 2.168 0c1.151-3.955 2.305-7.911 3.454-11.867a21.115 21.115 0 0 0 5.697-2.353l10.774 5.888a.95.95 0 0 0 .739.211c.272-.016.514-.141.702-.325c.208-.192.35-.451.367-.745a.962.962 0 0 0-.218-.743c-1.966-3.583-3.937-7.169-5.904-10.754a21.294 21.294 0 0 0 2.338-5.679c3.98-1.168 7.966-2.336 11.947-3.502c1.073-.314 1.077-1.857.002-2.17" /><circle cx="31.553" cy="31.836" r="17.901" fill="#f9ec21" /></svg>

              </Col>
              <Col xs="9">
                <div className="numbers">
                  <p className="card-category">Evening</p>
                  <p className="card-category" style={{ fontSize: "x-small" }}><b>3:30PM-7:30PM </b></p>

                </div>
              </Col>
            </Row>
          </Card.Body>

        </div><br />


        <div className={serveTime === "night" ? " icons-right " : " icons-right-not "}
          onClick={() => {
            setServeTime("night")
          }}>
          <Card.Body>
            <Row>
              <Col xs="3">
                <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 512 512"><defs><linearGradient id="meteoconsClearNightFill0" x1="54.3" x2="187.2" y1="29" y2="259.1" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#86c3db" /><stop offset=".5" stop-color="#86c3db" /><stop offset="1" stop-color="#5eafcf" /></linearGradient><symbol id="meteoconsClearNightFill1" viewBox="0 0 270 270"><path fill="url(#meteoconsClearNightFill0)" stroke="#72b9d5" stroke-linecap="round" stroke-linejoin="round" stroke-width="6" d="M252.3 168.6A133.4 133.4 0 0 1 118 36.2A130.5 130.5 0 0 1 122.5 3A133 133 0 0 0 3 134.6C3 207.7 63 267 137.2 267c62.5 0 114.8-42.2 129.8-99.2a135.6 135.6 0 0 1-14.8.8Z"><animateTransform additive="sum" attributeName="transform" dur="6s" repeatCount="indefinite" type="rotate" values="-15 135 135; 9 135 135; -15 135 135" /></path></symbol></defs><use width="270" height="270" href="#meteoconsClearNightFill1" transform="translate(121 121)" /></svg>

              </Col>
              <Col xs="9">
                <div className="numbers">
                  <p className="card-category">Night</p>
                  <p className="card-category" style={{ fontSize: "x-small" }}><b>7:30PM-12AM </b></p>

                </div>
              </Col>
            </Row>
          </Card.Body>

        </div><br />


        <div className={serveTime === "late_night" ? " icons-right " : " icons-right-not "}
          onClick={() => {
            setServeTime("late_night")
          }}>
          <Card.Body>
            <Row>
              <Col xs="3">
                <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 512 512"><defs><linearGradient id="meteoconsStarryNightFill0" x1="54.3" x2="187.2" y1="29" y2="259.1" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#86c3db" /><stop offset=".5" stop-color="#86c3db" /><stop offset="1" stop-color="#5eafcf" /></linearGradient><linearGradient id="meteoconsStarryNightFill1" x1="294" x2="330" y1="112.8" y2="175.2" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fcd966" /><stop offset=".5" stop-color="#fcd966" /><stop offset="1" stop-color="#fccd34" /></linearGradient><linearGradient id="meteoconsStarryNightFill2" x1="295.5" x2="316.5" y1="185.9" y2="222.1" href="#meteoconsStarryNightFill1" /><linearGradient id="meteoconsStarryNightFill3" x1="356.3" x2="387.7" y1="194.8" y2="249.2" href="#meteoconsStarryNightFill1" /><symbol id="meteoconsStarryNightFill4" viewBox="0 0 270 270"><path fill="url(#meteoconsStarryNightFill0)" stroke="#72b9d5" stroke-linecap="round" stroke-linejoin="round" stroke-width="6" d="M252.3 168.6A133.4 133.4 0 0 1 118 36.2A130.5 130.5 0 0 1 122.5 3A133 133 0 0 0 3 134.6C3 207.7 63 267 137.2 267c62.5 0 114.8-42.2 129.8-99.2a135.6 135.6 0 0 1-14.8.8Z"><animateTransform additive="sum" attributeName="transform" dur="6s" repeatCount="indefinite" type="rotate" values="-15 135 135; 9 135 135; -15 135 135" /></path></symbol></defs><path fill="url(#meteoconsStarryNightFill1)" stroke="#fcd34d" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m282.8 162.8l25-6.4a1.8 1.8 0 0 1 1.7.5l18.3 18a1.8 1.8 0 0 0 3-1.7l-6.4-25a1.8 1.8 0 0 1 .5-1.7l18-18.4a1.8 1.8 0 0 0-1.8-3l-24.9 6.5a1.8 1.8 0 0 1-1.7-.5l-18.4-18a1.8 1.8 0 0 0-3 1.7l6.5 25a1.8 1.8 0 0 1-.5 1.7l-18 18.3a1.8 1.8 0 0 0 1.7 3Z"><animateTransform additive="sum" attributeName="transform" calcMode="spline" dur="6s" keySplines=".42, 0, .58, 1; .42, 0, .58, 1" repeatCount="indefinite" type="rotate" values="-15 312 144; 15 312 144; -15 312 144" /><animate attributeName="opacity" dur="6s" values="1; .75; 1; .75; 1; .75; 1" /></path><path fill="url(#meteoconsStarryNightFill2)" stroke="#fcd34d" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m285.4 193.4l12 12.3a1.2 1.2 0 0 1 .3 1.1l-4.3 16.6a1.2 1.2 0 0 0 2 1.2l12.3-12a1.2 1.2 0 0 1 1.1-.3l16.6 4.3a1.2 1.2 0 0 0 1.2-2l-12-12.3a1.2 1.2 0 0 1-.3-1.1l4.3-16.6a1.2 1.2 0 0 0-2-1.2l-12.3 12a1.2 1.2 0 0 1-1.1.3l-16.7-4.3a1.2 1.2 0 0 0-1.1 2Z"><animateTransform additive="sum" attributeName="transform" begin="-.33s" calcMode="spline" dur="6s" keySplines=".42, 0, .58, 1; .42, 0, .58, 1" repeatCount="indefinite" type="rotate" values="-15 306 204; 15 306 204; -15 306 204" /><animate attributeName="opacity" begin="-.33s" dur="6s" values="1; .75; 1; .75; 1; .75; 1" /></path><path fill="url(#meteoconsStarryNightFill3)" stroke="#fcd34d" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m337.3 223.7l24.8 7a1.8 1.8 0 0 1 1.3 1.2l6.9 24.8a1.8 1.8 0 0 0 3.4 0l7-24.8a1.8 1.8 0 0 1 1.2-1.3l24.8-6.9a1.8 1.8 0 0 0 0-3.4l-24.8-7a1.8 1.8 0 0 1-1.3-1.2l-6.9-24.8a1.8 1.8 0 0 0-3.4 0l-7 24.8a1.8 1.8 0 0 1-1.2 1.3l-24.8 6.9a1.8 1.8 0 0 0 0 3.4Z"><animateTransform additive="sum" attributeName="transform" begin="-.67s" calcMode="spline" dur="6s" keySplines=".42, 0, .58, 1; .42, 0, .58, 1" repeatCount="indefinite" type="rotate" values="-15 372 222; 15 372 222; -15 372 222" /><animate attributeName="opacity" begin="-.67s" dur="6s" values="1; .75; 1; .75; 1; .75; 1" /></path><use width="270" height="270" href="#meteoconsStarryNightFill4" transform="translate(121 121)" /></svg>
              </Col>
              <Col xs="9">
                <div className="numbers">
                  <p className="card-category">Late Night</p>
                  <p className="card-category" style={{ fontSize: "x-small" }}><b>12AM -7AM </b></p>


                </div>
              </Col>
            </Row>
          </Card.Body>

        </div>

      </div>

      <div className="col-8" style={{}}>

        <div style={{ textAlign: "center", overflowX:'hidden' }}>


          {tapedData.length > 0 && <div style={{ marginBottom: "1%", textAlign: "left" }} className="row">

            <div className="col-1"></div>
            <div style={{ backgroundColor: "rgb(43, 147, 160)", color: "white", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>Patient</div></div>
            <div style={{ backgroundColor: "rgb(43, 147, 160)", color: "white", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>Carer</div></div>
            <div style={{ backgroundColor: "rgb(43, 147, 160)", color: "white", border: "2px solid white", borderRadius: "5px", }} className="col-2"><div style={{ paddingTop: "6%", paddingBottom: "2%", }}>Time</div></div>

          </div>}
          <SimpleBar style={{ maxHeight: "80vh", overflowX:'hidden' }}>
          {tapedData.length > 0 ? tapedData.map((item) => {
            return (<>
              <div style={{ marginBottom: "1%", textAlign: "left", textTransform: "capitalize" }} className="row">

                <div className="col-1"></div>
                <div style={{ backgroundColor: "aliceblue", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>{item.patient_name}</div></div>
                <div style={{ backgroundColor: "aliceblue", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>{item.tap_users[item.tap_users.length - 1].tapping_username}{item.tap_users.length > 1 && <OverlayTrigger
                  trigger="click"
                  rootClose
                  placement="right"
                  overlay={
                    <Tooltip className="tap-tooltip" id="button-tooltip">
                      <SimpleBar style={{ maxHeight: "100px", width: "100%" }}>
                        {item.tap_users.map((i, index) => {
                          return (index !== item.tap_users.length - 1 && <>

                            <span className="col-7" ><b>{i.tapping_username}&nbsp;&nbsp;{i.tap_time.slice(11, 16)}</b></span><br />
                          </>
                          )
                        })
                        }
                      </SimpleBar>
                    </Tooltip>
                  }
                ><span style={{ color: "blue", cursor: "pointer" }}>&nbsp;&nbsp;+{item.tap_users.length - 1}</span></OverlayTrigger>}</div></div>
                <div style={{ backgroundColor: "aliceblue", border: "2px solid white", borderRadius: "5px", }} className="col-2"><div style={{ paddingTop: "6%", paddingBottom: "2%", }}>{item.tap_users[item.tap_users.length - 1].tap_time.slice(11, 16)}</div></div>

              </div>

            </>
            )
          }) : <div style={{ padding: "20%" }} className="text-warning">
            <h4><b> No Taps</b></h4>
          </div>
          }
          </SimpleBar>
        </div>
      </div>
      <div className="col-2" style={{ fontSize: "small", justifyContent: "center" }}>



        <div style={{ width: "85%" }}  onClick={() => { setDate(new Date());setTimeRefres(!timeRefresh);}} className={tapped ? "icons-right" : "icons-right-not"}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.75 7c1.348 0 2.179.97 2.246 2.329l.004.18v2.115l2.219.403a3.252 3.252 0 0 1 2.602 3.857l-.043.18l-1.048 3.923a2.25 2.25 0 0 1-1.689 1.616l-.165.03l-2.418.347a2.25 2.25 0 0 1-2.28-1.123l-.08-.155l-.03-.063a3.464 3.464 0 0 0-1.025-1.283l-.194-.138l-1.884-1.256l-.093-.059l-.098-.052l-2.363-1.175a.75.75 0 0 1-.416-.655c-.024-1.109.466-1.964 1.42-2.44c.701-.352 1.634-.332 2.826.016l.259.08v-4.17C9.5 8.055 10.342 7 11.75 7m0 1.5c-.46 0-.713.275-.746.866L11 9.508v5.245a.75.75 0 0 1-1.036.693c-1.46-.602-2.441-.743-2.879-.524c-.254.127-.42.29-.51.519l-.038.12l1.905.947l.181.097l.174.109l1.884 1.256a4.966 4.966 0 0 1 1.626 1.792l.122.245l.03.062a.75.75 0 0 0 .677.434l.109-.008l2.418-.347a.75.75 0 0 0 .581-.443l.037-.105l1.048-3.924a1.75 1.75 0 0 0-1.239-2.142l-.07-.017l-2.904-.529a.75.75 0 0 1-.609-.63l-.007-.108V9.508c0-.69-.255-1.008-.75-1.008M11.749 2a7.25 7.25 0 0 1 6.697 10.034a4.204 4.204 0 0 0-1.305-.785a5.75 5.75 0 1 0-10.219 1.13a3.316 3.316 0 0 0-.955.307c-.16.08-.312.17-.455.266A7.25 7.25 0 0 1 11.748 2m0 2.502A4.749 4.749 0 0 1 16.165 11L15 10.789V9.51l-.004-.195l.002-.063a3.24 3.24 0 0 0-.567-1.835l-.09-.132C13.783 6.496 12.891 6 11.75 6c-1.175 0-2.085.526-2.64 1.353a3.237 3.237 0 0 0-.61 1.898l.002.11l-.002.147v2.89l-.262-.036a1 1 0 0 1-.617-.32C7.207 11.583 7 10.653 7 9.25a4.749 4.749 0 0 1 4.749-4.75" /></svg>
          <br />New Taps  {tapped && <span style={{ background: "red", borderRadius: "20%" }}>&nbsp;&nbsp;{count}&nbsp;&nbsp;</span>}</div><br />

      </div>
    </div></>)
}
export default CareTouch;